import router from '@/router';

export default {
  namespaced: true,
  state: () => ({
    firstname: 'Max',
    lastname: 'Mustermann',
    title: 'Herr',
    salutation: 'Willkommen im Hotel,',
  }),
  mutations: {
    setFirstName(state, value = '') {
      state.firstname = value;
    },
    setLastName(state, value = '') {
      state.lastname = value;
    },
    setTitle(state, value = '') {
      state.title = value;
    },
    setSalutation(state, value = '') {
      state.salutation = value;
    },
  },
  actions: {
    init(
      { commit, getters },
      { lastname, firstname, title, salutation, language }
    ) {
      if (lastname) commit('setLastName', lastname);
      if (firstname) commit('setFirstName', firstname);
      if (title) commit('setTitle', title);
      if (salutation) commit('setSalutation', salutation);
      if (language) dispatch('lang/set', language, { root: true });
      router.push('welcome');
    },
    clear({ commit }) {
      commit('setLastName');
      commit('setFirstName');
      commit('setTitle');
      // commit('setSalutation');
    },
    leave({ dispatch }) {
      dispatch('clear');
      router.push({ name: 'Home' });
    },
  },
  getters: {
    getHasWelcomeValues(state) {
      if (state.firstname.length > 0) return true;
      if (state.lastname.length > 0) return true;
      if (state.title.length > 0) return true;
      return false;
    },
    getName(state) {
      if (state.title.length <= 0) {
        return state.firstname + ' ' + state.lastname;
      }
      return `${state.title} ${state.firstname} ${state.lastname}`;
    },
    getTitle(state) {
      return state.title;
    },
    getSalutation(state) {
      return state.salutation;
    },
    getTextStyles(state, getters, rootState, rootGetters) {
      const values = rootGetters['customizer/getWelcomeValues'];
      return {
        color: values.welcomeTextColor,
        backgroundColor: values.welcomeDetailActiveBackgroundColor,
      };
    },
  },
};



// WEBPACK FOOTER //
// ./src/store/modules/welcome.js